export default class Map {

  constructor(el) {
    this.el = el;

    this.coordinates = JSON.parse(this.el.dataset.hwcMap); 
  
    this.init(); 
  } 


  init(){ 
    this.initMap(); 
  }       

  initMap(){
     
    /* Instanciate Leaflet map */
    this.map = L.map(this.el, {
      center: [this.coordinates[0], this.coordinates[1]],
      zoom: 10,
      gestureHandling: true
    });  

    /* Add Tiles to the map */
    L.tileLayer('https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(this.map)
  
    this.setMarker(); 
  }  

  setMarker(){ 

    const icon = L.divIcon({
      html: '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="76" fill="none"><path fill="#00AAD2" fill-rule="evenodd" d="M23.934 73.256c1.012 1.416 1.61 2.744 3.07 2.744 1.46 0 2.059-1.328 3.07-2.744C42.521 55.944 54 39.962 54 26.996 54 12.086 41.914 0 26.996 0 12.077 0 0 12.086 0 27.005c0 12.957 11.488 28.94 23.934 46.25Z" clip-rule="evenodd"/><path fill="#fff" d="M28.773 27.787a1.454 1.454 0 0 0-1.956.511l-2.236 3.775-4.08-.002c-.79 0-1.431.623-1.432 1.392 0 .769.64 1.393 1.43 1.394h2.432l-1.561 2.638a1.373 1.373 0 0 0 .525 1.902c.686.384 1.561.155 1.956-.511l5.446-9.197a1.373 1.373 0 0 0-.525-1.902m12.898-7.404-10.91.01c-.79 0-1.431.624-1.43 1.393 0 .769.642 1.392 1.433 1.39l4.479-.003 2.037 3.438c.395.666 1.271.895 1.956.51.684-.383.92-1.235.525-1.902l-1.216-2.049 3.128-.003c.79 0 1.43-.624 1.43-1.393 0-.77-.642-1.392-1.433-1.391m-8.882 5.068a1.453 1.453 0 0 0-1.956-.508 1.372 1.372 0 0 0-.523 1.904l2.243 3.771-2.041 3.436a1.373 1.373 0 0 0 .523 1.903c.684.385 1.56.158 1.955-.508l1.218-2.049 1.566 2.634a1.453 1.453 0 0 0 1.956.508 1.372 1.372 0 0 0 .522-1.904l-5.464-9.186h.001Zm-7.018-3.979c.685.384 1.56.155 1.955-.511l2.236-3.775 4.08.002c.79 0 1.431-.623 1.432-1.392 0-.77-.64-1.393-1.43-1.394H31.61l1.561-2.638a1.373 1.373 0 0 0-.525-1.902 1.454 1.454 0 0 0-1.956.511l-5.446 9.197a1.373 1.373 0 0 0 .525 1.902m-.56 6.001c0-.769-.642-1.392-1.432-1.391l-4.479.004-2.037-3.438a1.453 1.453 0 0 0-1.956-.51 1.372 1.372 0 0 0-.524 1.902l1.214 2.05-3.128.002c-.792 0-1.432.624-1.432 1.393 0 .77.643 1.392 1.433 1.392l10.91-.01c.791 0 1.431-.624 1.43-1.393m-3.456-3.666a1.453 1.453 0 0 0 1.957.507 1.372 1.372 0 0 0 .522-1.903l-2.243-3.771 2.041-3.436a1.372 1.372 0 0 0-.523-1.903 1.453 1.453 0 0 0-1.955.51l-1.217 2.048-1.566-2.634a1.453 1.453 0 0 0-1.957-.508 1.372 1.372 0 0 0-.522 1.903l5.464 9.187Z"/></svg>',
      className: 'leaflet-svg-icon',  
      iconSize: [54, 76],
      iconAnchor: [27, 76]
    });
   
    let leafletMarker = L.marker([this.coordinates[0], this.coordinates[1]], { icon }); 
    leafletMarker.addTo(this.map);  
  } 
}
